import { h } from "preact";
import { useTranslationContext } from "../context/translation.js";

/**
 * Common pagination footer for tables.
 *
 * @param param0
 * @returns
 */
export function Pagination({
  currentPage,
  onFirstPage,
  onPrevious,
  onNext,
}: {
  currentPage: number;
  onFirstPage?: () => void;
  onPrevious?: () => void;
  onNext?: () => void;
}) {
  const { i18n } = useTranslationContext();
  return (
    <nav
      class="flex flex-col gap-3 border-t border-gray-200 bg-white px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-6 dark:border-gray-700 dark:bg-gray-950"
      aria-label={i18n.str`Pagination`}
    >
      <p
        class="text-sm font-medium text-gray-700 dark:text-gray-300"
        aria-live="polite"
      >
        {i18n.str`Page ${currentPage}`}
      </p>
      <div class="flex justify-between sm:justify-end">
        <button
          class="relative inline-flex min-h-11 items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0 disabled:bg-gray-100 disabled:text-gray-500 dark:bg-gray-950 dark:text-gray-100 dark:ring-gray-600 dark:hover:bg-gray-900 dark:disabled:bg-gray-800 dark:disabled:text-gray-400"
          disabled={!onFirstPage}
          onClick={onFirstPage}
        >
          <i18n.Translate>First page</i18n.Translate>
        </button>
        <button
          class="relative ml-3 inline-flex min-h-11 items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0 disabled:bg-gray-100 disabled:text-gray-500 dark:bg-gray-950 dark:text-gray-100 dark:ring-gray-600 dark:hover:bg-gray-900 dark:disabled:bg-gray-800 dark:disabled:text-gray-400"
          disabled={!onPrevious}
          onClick={onPrevious}
        >
          <i18n.Translate>Previous</i18n.Translate>
        </button>
        <button
          class="relative ml-3 inline-flex min-h-11 items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0 disabled:bg-gray-100 disabled:text-gray-500 dark:bg-gray-950 dark:text-gray-100 dark:ring-gray-600 dark:hover:bg-gray-900 dark:disabled:bg-gray-800 dark:disabled:text-gray-400"
          disabled={!onNext}
          onClick={onNext}
        >
          <i18n.Translate>Next</i18n.Translate>
        </button>
      </div>
    </nav>
  );
}
